<template>
  <Tag :value="label" :severity="severity" />
</template>

<script setup lang="ts">
const props = defineProps<{ category: string | null | undefined }>();

const config: Record<string, { label: string; severity: 'success' | 'info' | 'warn' | 'danger' | 'secondary' | 'contrast' }> = {
  student_copy: { label: 'Student Copy', severity: 'info' },
  official_soft_copy: { label: 'Official Soft Copy', severity: 'contrast' },
  official_hard_copy: { label: 'Official Hard Copy', severity: 'warn' },
};

const normalised = computed(() => (props.category ?? '').toString().toLowerCase());
const label = computed(() => config[normalised.value]?.label ?? props.category ?? '—');
const severity = computed(() => config[normalised.value]?.severity ?? 'secondary');
</script>
